/**
 * 檔案用途區塊
 * @module GoogleSsoPage
 * @purpose 定義 Google 第三方登入頁面的容器元件，負責承載登入元件與版面結構。
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import { useThirdPartyProvider } from '@shared/models';
import GoogleLogin from '@modules/google/components/GoogleLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description Google 第三方登入頁面的主要函式元件。
 * @purpose 組合頁面版型與 GoogleLogin 元件，作為 Google SSO 入口頁。
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
const GoogleSsoPage = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 取得第三方登入流程共享的提供者資料。
   * @purpose 觸發並維持與第三方登入上下文的資料連結。
   * @external https://innotech.atlassian.net/browse/IN-46601
   */
  const { payload } = useThirdPartyProvider();

  return (
    <ContentLayout testId="GoogleSsoPage">
      <GoogleLogin />
    </ContentLayout>
  );
};

export default GoogleSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:11:52.166Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotations (top/middle/bottom), included declaration-level comments for mapped signatures, used only IN-46601 with full Jira URLs, and kept runtime logic unchanged.
 */
